// extracted by mini-css-extract-plugin
export default {"wrapperSelect":"Childrens_wrapperSelect__6dd4k","select":"Childrens_select__Oykvc"};